import BigNumber from 'bignumber.js'

export function showTimeEn (time, nowTime) {
  if (!time) return '--'
  let newNowTime = new Date(nowTime).getTime()
  let now = parseInt(newNowTime.toString().substring(0, 13))
  time = parseInt(time.toString().substring(0, 13))
  const diff = (now - time) / 1000
  if (diff < 60) {
    return Math.ceil(diff) + 's ago'
  } else if (diff < 3600) {
    return Math.floor(diff / 60) + 'min ago'
  } else if (diff < 3600 * 24) {
    return Math.floor(diff / 3600) + 'h ago'
  }
}

export function formatRelativeDate (dateString) {
  // Parse the input date string into a Date object
  const givenDate = new Date(dateString)
  const now = new Date()

  // Calculate the difference in milliseconds
  const diff = now - givenDate

  // Convert the difference to various units
  const diffInSeconds = Math.floor(diff / 1000)
  const diffInMinutes = Math.floor(diffInSeconds / 60)
  const diffInHours = Math.floor(diffInMinutes / 60)
  const diffInDays = Math.floor(diffInHours / 24)

  // format the time text
  const sec = `sec${diffInSeconds > 1 ? 's' : ''}`
  const minute = `minute${diffInMinutes > 1 ? 's' : ''}`
  const hour = `hour${diffInHours > 1 ? 's' : ''}`
  const day = `day${diffInDays > 1 ? 's' : ''}`

  // Format the date based on the difference
  if (diffInSeconds < 60) {
    return `${diffInSeconds} ${sec} ago`
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} ${minute} ago`
  } else if (diffInHours < 24) {
    return `${diffInHours} ${hour} ago`
  } else {
    return `${diffInDays} ${day} ago`
  }
}

export function formatTokenSupply (supply, decimals) {
  if (supply === null || typeof supply === 'undefined') return '--'
  if (decimals === null || typeof decimals === 'undefined') return '--'

  // Initialize BigNumber instances
  const supplyBN = new BigNumber(supply)
  const decimalsBN = new BigNumber(10).pow(decimals)

  // Divide supply by 10^decimals
  const resultBN = supplyBN.dividedBy(decimalsBN)

  // Convert to string with fixed decimal points, avoiding scientific notation
  const resultStr = resultBN.toFixed()

  // Format with commas for large numbers and remove trailing zeros
  const formattedStr = addCommas(resultStr)

  return formattedStr
}

// Helper function to format numbers with commas
function addCommas (numberStr) {
  const [integerPart, decimalPart] = numberStr.split('.')
  // Add commas to the integer part
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  // Return the formatted number
  return decimalPart ? `${formattedInteger}.${decimalPart.replace(/0+$/, '')}` : formattedInteger
}

export function formatBalanceWithCommas (balance) {
  if (balance === null || balance === undefined || balance === '') return '--'

  try {
    // Initialize BigNumber to handle the input
    const balanceBN = new BigNumber(balance)

    // Check if the number is valid
    if (!balanceBN.isFinite()) return '--'

    // Convert to a string with fixed decimal points if needed
    const balanceStr = balanceBN.toFixed()

    // Format the number with commas
    const formattedBalance = addCommas2(balanceStr)

    return formattedBalance
  } catch (error) {
    // Return '--' if any error occurs during formatting
    return '--'
  }
}

// Helper function to add commas
function addCommas2 (numberStr) {
  const [integerPart, decimalPart] = numberStr.split('.')

  // Add commas to the integer part using regex
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  // Return the formatted number with the decimal part if it exists
  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger
}

